type ProductCategory = {
  value: string
  label: string
}

const PRODUCT_CATEGORIES: ProductCategory[] = [
  { value: "electronics", label: "Electronics" },
  { value: "clothing", label: "Clothing" },
  { value: "home", label: "Home" },
  { value: "sports", label: "Sports" },
  { value: "books", label: "Books" },
  { value: "other", label: "Other" }
]

export { PRODUCT_CATEGORIES }
export type { ProductCategory }
